import { render } from "./team-sec.vue?vue&type=template&id=36a854ec&scoped=true"
import script from "./team-sec.vue?vue&type=script&lang=js"
export * from "./team-sec.vue?vue&type=script&lang=js"

import "./team-sec.vue?vue&type=style&index=0&id=36a854ec&lang=css"
import "./team-sec.vue?vue&type=style&index=1&id=36a854ec&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a854ec"]])

export default __exports__